import { writable } from 'svelte/store';

export const score = writable(0);
export const country = writable({flag: '', name: ''});
export const paused = writable(false);
export const gameStarted = writable(false);
export const timerSeconds = writable(300);
export const countriesLoaded = writable(false);
export const randomizedCountries = writable([]);